import { observer } from 'mobx-react-lite';
import { useTranslation } from '@shared/utils/i18n';
import { Box, Checkbox, FormControlLabel, TextField } from '@mui/material';
import {
  type OsiPastInvoicesViewModel,
  OsiPastInvoicesViewModelIdentifier
} from '@shared/types/mobx/widgets/OsiPastInvoicesWidget';
import { useInjection } from 'inversify-react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { LOCALES } from '@shared/utils/i18n/locales';
import { DatePicker, LoadingButton } from '@mui/lab';
import { Trans } from 'react-i18next';

export const OsiPastInvoices: React.FC = observer(() => {
  const { t, getGridLocale, intl } = useTranslation();
  const vm = useInjection<OsiPastInvoicesViewModel>(OsiPastInvoicesViewModelIdentifier);

  const columns = [
    {
      field: 'flat',
      headerName: t('invoices:partialInvoices.flat'),
      flex: 1
    },
    {
      field: 'name',
      headerName: t('invoices:partialInvoices.owner'),
      flex: 3
    },
    {
      field: `areaTypeName${intl.locale === LOCALES.RU ? 'Ru' : 'Kz'}`,
      headerName: t('invoices:partialInvoices.areaType'),
      flex: 1
    },
    {
      field: 'id',
      headerName: t('invoices:partialInvoices.id'),
      flex: 1
    },
    {
      field: 'square',
      headerName: t('invoices:partialInvoices.square'),
      flex: 1
    }
  ];

  return (
    <Box>
      <DatePicker
        views={['year', 'month']}
        openTo={'month'}
        disabled={vm.isLoading}
        onAccept={(date: Date | null) => {
          if (!date) return;
          vm.date = date;
        }}
        label={t('common:date')}
        minDate={new Date('2023-01-01')}
        maxDate={new Date()}
        value={vm.date}
        onChange={() => null}
        renderInput={(params) => <TextField size="small" {...params} helperText={null} />}
      />
      <LoadingButton
        loading={vm.isLoading}
        variant="outlined"
        color="primary"
        onClick={vm.downloadInvoices}
        sx={{ mb: 2, ml: 1 }}
        size="medium"
      >
        <Trans i18nKey={'invoices:pastInvoices.mainButton'} />
      </LoadingButton>
      {/* OSI-845: галочка «Отдельными квитанциями» справа от «Сформировать» — несколько квартир скачиваются ZIP-архивом */}
      <FormControlLabel
        control={
          <Checkbox
            checked={vm.isSeparateFiles}
            onChange={(_, checked) => vm.setIsSeparateFiles(checked)}
            disabled={vm.isLoading}
          />
        }
        label={t('invoices:separateInvoices')}
        sx={{ mb: 2, ml: 1 }}
      />
      <Box sx={{ width: 1000, height: 'auto' }}>
        <DataGridPro
          loading={vm.isLoading}
          localeText={getGridLocale()}
          rows={vm.abonents}
          columns={columns}
          density="compact"
          checkboxSelection
          onSelectionModelChange={vm.onSelectionModelChange}
          selectionModel={vm.selectionModel}
          hideFooter
        />
      </Box>
    </Box>
  );
});
